import type { SchoolAnalyticsResponse } from "@/client"

function csvEscape(value: string | number | null | undefined) {
  if (value === null || value === undefined) {
    return ""
  }

  const text = String(value)
  return /[",\n]/.test(text) ? `"${text.split('"').join('""')}"` : text
}

function toCsv(rows: Array<Array<string | number | null | undefined>>) {
  return rows.map((row) => row.map(csvEscape).join(",")).join("\n")
}

export function buildSchoolRowsCsv(data: SchoolAnalyticsResponse) {
  return toCsv([
    [
      "school",
      "unique_students",
      "started_attempts",
      "completed_attempts",
      "completion_rate",
      "avg_score_percentage",
      "avg_percentile",
      "rank",
      "hidden_reason",
    ],
    ...data.schools.map((school) => [
      school.school_name,
      school.unique_students,
      school.started_attempts,
      school.completed_attempts,
      school.completion_rate,
      school.avg_score_percentage,
      school.avg_percentile,
      school.rank,
      school.metrics_hidden_reason,
    ]),
  ])
}

export function buildSchoolSubjectCsv(data: SchoolAnalyticsResponse) {
  return toCsv([
    [
      "school",
      "subject",
      "unique_students",
      "answered_questions",
      "correctness_rate",
      "org_correctness_rate",
      "delta_from_org",
    ],
    ...data.schools.flatMap((school) =>
      (school.subject_details ?? []).map((subject) => [
        school.school_name,
        subject.subject_name,
        subject.unique_students,
        subject.answered_questions,
        subject.correctness_rate,
        subject.org_correctness_rate,
        subject.delta_from_org,
      ]),
    ),
  ])
}
